import React from "react";
import { Routes, Route } from "react-router-dom";
import GlobalStyles from "./GlobalStyles";

import RequireAuth from "./Analysis/pages/RequireAuth";
import Homepage from "./Home/Pages/Homepage";
import PageNotFound from "./Analysis/pages/PageNotFound";
import Quiz from "./Quiz/pages/Quiz";
import QuizMobile from "./Quiz/pages/QuizMobile";
import Analysis from "./Quiz/pages/Analysis";
import AnalysisMobile from "./Quiz/pages/AnalysisMobile";
import Register from "./Quiz/pages/Register";
import RegisterMobile from "./Quiz/pages/RegisterMobile";

function App() {
  return (
    <div className="App">
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route
          path="/register"
          element={window.innerWidth > 700 ? <Register /> : <RegisterMobile />}
        />
        <Route
          path="/analysis/:email"
          element={window.innerWidth > 700 ? <Analysis /> : <AnalysisMobile />}
        />
        <Route path="*" element={<PageNotFound />} />
        <Route element={<RequireAuth />}>
          <Route
            path="/quiz"
            element={window.innerWidth > 700 ? <Quiz /> : <QuizMobile />}
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
